import { service } from ".";

export const forgotPassword = (params: {registeredEmail: string}) => service('/api/v1/accounts/self-forgot-pwd', {method: 'POST', params});

export const setNewPassword = (params: {newPassword: string, token: string}) => service('/api/v1/accounts/self-forgot-pwd-validate-token', {method: 'POST', params});